import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { alert_error, alert_success } from "../../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { update_input_url_orders, update_shop_insurance } from '../../../../order/orders/actions.js';
import Orders from "../../../../order/orders/orders.jsx";
import { Cookies } from '../../../../index.js';

const Account_home = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const set_input_url_orders = (value) => {
        dispatch(update_input_url_orders(value));
    };
    const set_shop_insurance = (value) => {
        dispatch(update_shop_insurance(value));
    };
    const api_response = useSelector(state => state.api_response);

    function switch_router(link) {
        navigate(link);
    };
    useEffect(() => {
        reset_profile();
    }, []);

    useEffect(() => {
        if (api_response && typeof api_response === "object" && "order" in api_response) {
            reset_profile();
        }
    }, [api_response]);


    function reset_profile() {
        const apiKey = Cookies.get('apikey');
        axios
            .post('https://hust.media/api/profile/profile.php', {
                apikey: apiKey,
                chedo: 'accounts_profile',
            })
            .then((response) => {
                const { shop_caption, shop_description, shop_insurance } = response.data;
                set_input_url_orders({ shop_caption, shop_description, shop_insurance });
                set_shop_insurance(response.data.shop_insurance);

            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Orders category_main='accounts_shop_profile_edit' />
        </>
    );
};

export default Account_home;
